import { forwardRef } from 'react';

export const BuildingIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 42 42" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.52722 37.7235C1.52722 37.4072 1.78364 37.1508 2.09995 37.1508H40.2818C40.5981 37.1508 40.8545 37.4072 40.8545 37.7235C40.8545 38.0398 40.5981 38.2962 40.2818 38.2962H2.09995C1.78364 38.2962 1.52722 38.0398 1.52722 37.7235Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.26929 7.02536C5.26929 6.70906 5.52571 6.45264 5.84201 6.45264H35.9675C36.2838 6.45264 36.5402 6.70906 36.5402 7.02536V34.8981C36.5402 35.2144 36.2838 35.4708 35.9675 35.4708H5.84201C5.52571 35.4708 5.26929 35.2144 5.26929 34.8981V7.02536ZM6.41474 7.59809V34.3254H35.3947V7.59809H6.41474Z"
        />
        <path d="M12.1419 10.1182H8.51465V15.12H12.1419V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94202 10.1181C7.94202 9.80183 8.19844 9.54541 8.51474 9.54541H12.142C12.4583 9.54541 12.7147 9.80183 12.7147 10.1181V15.12C12.7147 15.4363 12.4583 15.6927 12.142 15.6927H8.51474C8.19844 15.6927 7.94202 15.4363 7.94202 15.12V10.1181ZM9.08747 10.6909V14.5472H11.5693V10.6909H9.08747Z"
        />
        <path d="M19.1293 10.1182H15.5021V15.12H19.1293V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 10.1181C14.9294 9.80183 15.1859 9.54541 15.5022 9.54541H19.1294C19.4458 9.54541 19.7022 9.80183 19.7022 10.1181V15.12C19.7022 15.4363 19.4458 15.6927 19.1294 15.6927H15.5022C15.1859 15.6927 14.9294 15.4363 14.9294 15.12V10.1181ZM16.0749 10.6909V14.5472H18.5567V10.6909H16.0749Z"
        />
        <path d="M26.1159 10.1182H22.4886V15.12H26.1159V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9159 10.1181C21.9159 9.80183 22.1723 9.54541 22.4886 9.54541H26.1159C26.4322 9.54541 26.6886 9.80183 26.6886 10.1181V15.12C26.6886 15.4363 26.4322 15.6927 26.1159 15.6927H22.4886C22.1723 15.6927 21.9159 15.4363 21.9159 15.12V10.1181ZM23.0613 10.6909V14.5472H25.5432V10.6909H23.0613Z"
        />
        <path d="M33.1033 10.1182H29.4761V15.12H33.1033V10.1182Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9034 10.1181C28.9034 9.80183 29.1599 9.54541 29.4762 9.54541H33.1034C33.4197 9.54541 33.6762 9.80183 33.6762 10.1181V15.12C33.6762 15.4363 33.4197 15.6927 33.1034 15.6927H29.4762C29.1599 15.6927 28.9034 15.4363 28.9034 15.12V10.1181ZM30.0489 10.6909V14.5472H32.5307V10.6909H30.0489Z"
        />
        <path d="M12.1419 17.7927H8.51465V22.7945H12.1419V17.7927Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94202 17.7927C7.94202 17.4764 8.19844 17.22 8.51474 17.22H12.142C12.4583 17.22 12.7147 17.4764 12.7147 17.7927V22.7945C12.7147 23.1108 12.4583 23.3672 12.142 23.3672H8.51474C8.19844 23.3672 7.94202 23.1108 7.94202 22.7945V17.7927ZM9.08747 18.3654V22.2218H11.5693V18.3654H9.08747Z"
        />
        <path d="M19.1293 17.7927H15.5021V22.7945H19.1293V17.7927Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 17.7927C14.9294 17.4764 15.1859 17.22 15.5022 17.22H19.1294C19.4458 17.22 19.7022 17.4764 19.7022 17.7927V22.7945C19.7022 23.1108 19.4458 23.3672 19.1294 23.3672H15.5022C15.1859 23.3672 14.9294 23.1108 14.9294 22.7945V17.7927ZM16.0749 18.3654V22.2218H18.5567V18.3654H16.0749Z"
        />
        <path d="M26.1159 17.7927H22.4886V22.7945H26.1159V17.7927Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9159 17.7927C21.9159 17.4764 22.1723 17.22 22.4886 17.22H26.1159C26.4322 17.22 26.6886 17.4764 26.6886 17.7927V22.7945C26.6886 23.1108 26.4322 23.3672 26.1159 23.3672H22.4886C22.1723 23.3672 21.9159 23.1108 21.9159 22.7945V17.7927ZM23.0613 18.3654V22.2218H25.5432V18.3654H23.0613Z"
        />
        <path d="M33.1033 17.7927H29.4761V22.7945H33.1033V17.7927Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9034 17.7927C28.9034 17.4764 29.1599 17.22 29.4762 17.22H33.1034C33.4197 17.22 33.6762 17.4764 33.6762 17.7927V22.7945C33.6762 23.1108 33.4197 23.3672 33.1034 23.3672H29.4762C29.1599 23.3672 28.9034 23.1108 28.9034 22.7945V17.7927ZM30.0489 18.3654V22.2218H32.5307V18.3654H30.0489Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.94202 25.5053C7.94202 25.189 8.19844 24.9326 8.51474 24.9326H12.142C12.4583 24.9326 12.7147 25.189 12.7147 25.5053V30.889C12.7147 31.2053 12.4583 31.4617 12.142 31.4617H8.51474C8.19844 31.4617 7.94202 31.2053 7.94202 30.889V25.5053ZM9.08747 26.0781V30.3163H11.5693V26.0781H9.08747Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.9294 25.5053C14.9294 25.189 15.1859 24.9326 15.5022 24.9326H19.1294C19.4458 24.9326 19.7022 25.189 19.7022 25.5053V34.8217C19.7022 35.138 19.4458 35.3944 19.1294 35.3944H15.5022C15.1859 35.3944 14.9294 35.138 14.9294 34.8217V25.5053ZM16.0749 26.0781V34.249H18.5567V26.0781H16.0749Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M21.9159 25.5053C21.9159 25.189 22.1723 24.9326 22.4886 24.9326H26.1159C26.4322 24.9326 26.6886 25.189 26.6886 25.5053V30.889C26.6886 31.2053 26.4322 31.4617 26.1159 31.4617H22.4886C22.1723 31.4617 21.9159 31.2053 21.9159 30.889V25.5053ZM23.0613 26.0781V30.3163H25.5432V26.0781H23.0613Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M28.9034 25.5053C28.9034 25.189 29.1599 24.9326 29.4762 24.9326H33.1034C33.4197 24.9326 33.6762 25.189 33.6762 25.5053V30.889C33.6762 31.2053 33.4197 31.4617 33.1034 31.4617H29.4762C29.1599 31.4617 28.9034 31.2053 28.9034 30.889V25.5053ZM30.0489 26.0781V30.3163H32.5307V26.0781H30.0489Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.26929 5.15451C5.26929 4.83821 5.52571 4.58179 5.84201 4.58179H35.9675C36.2838 4.58179 36.5402 4.83821 36.5402 5.15451V7.02542C36.5402 7.34173 36.2838 7.59815 35.9675 7.59815H5.84201C5.52571 7.59815 5.26929 7.34173 5.26929 7.02542V5.15451ZM6.41474 5.72724V6.4527H35.3947V5.72724H6.41474Z"
        />
      </svg>
    );
  },
);
